var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManagementRolesSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.667 2.667c0 .368-.299.666-.667.666H1c-.368 0-.667-.298-.667-.666v-2C.333.298.632 0 1 0h14c.368 0 .667.298.667.667v2zM15 4.667v6.666c0 .369-.298.667-.667.667H1.667C1.298 12 1 11.702 1 11.333V4.667",
    transform: "translate(0 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.333 6.333c0 .553-.447 1-1 1H6.667c-.553 0-1-.447-1-1 0-.552.447-1 1-1h2.666c.553 0 1 .448 1 1h0z",
    transform: "translate(0 2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementRolesSmall);
export default __webpack_public_path__ + "static/media/management-roles-small.80efafb7a7c2e5876b4f4a2c20f1e74c.svg";
export { ForwardRef as ReactComponent };